var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { MDCFormField } from '@material/form-field';
import { MDCRadio } from '@material/radio';
import WithRender from './Radio.html';
let RadioButton = class RadioButton extends Vue {
    constructor() {
        super(...arguments);
        this.id = '';
    }
    get checked() {
        return this.value === this.picked;
    }
    created() {
        this.id = this.id = 'mom-mdc-radio_' + this._uid;
    }
    mounted() {
        const el = this.$el;
        this.mdcFormField = new MDCFormField(el);
        this.mdcRadio = new MDCRadio(this.$refs.radioElm);
        this.mdcFormField.input = this.mdcRadio;
        this.onDisabledProp();
    }
    onInput() {
        this.$emit('input', this.value);
    }
    onDisabledProp() {
        this.mdcRadio.disabled = this.disabled;
    }
    onValueProp() {
        this.mdcRadio.value = this.value;
    }
    beforeDestroy() {
        this.mdcFormField.destroy();
        this.mdcRadio.destroy();
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], RadioButton.prototype, "disabled", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], RadioButton.prototype, "name", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], RadioButton.prototype, "value", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], RadioButton.prototype, "picked", void 0);
__decorate([
    Watch('disabled'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RadioButton.prototype, "onDisabledProp", null);
__decorate([
    Watch('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RadioButton.prototype, "onValueProp", null);
RadioButton = __decorate([
    WithRender,
    Component({
        model: {
            event: 'input',
            prop: 'picked'
        }
    })
], RadioButton);
export default RadioButton;
//# sourceMappingURL=Radio.js.map